import Image from "next/image"
import Footer from "src/components/footer"
import StyledText from "src/typography/typography-component"
import skColors from "styles/skColors"
import styles from "styles/LandingPage/about-us.module.scss"

import InlineExpandStrip, { Person } from "src/components/AboutUs/HorizontalCollapsibleRow"
import Network from "src/content/Network"
import NavBarPatients from "src/components/LandingPage/navbars/NavBarPatients"
import { GetStaticProps } from "next"
import { useTranslations } from "next-intl"
import SkinuvitaSeoHead from "../src/components/LandingPage/SkinuvitaSeoHead"
import { Routes } from "../src/data/routes"

/* ---------------- Team data ---------------- */
const TEAM: Person[] = [
  {
    key: "till",
    name: "Till Fitzke",
    title: "Front-end Developer & Projektmanager",
    img: "/images/about_us/team/Till.png",
    linkedin: "https://www.linkedin.com/in/till-fitzke-470717193/",
  },
  {
    key: "janina",
    name: "Janina Clasen",
    title: "Quality & Regulatory Managerin",
    img: "/images/about_us/team/Janina.png",
    linkedin: "https://www.linkedin.com/in/janina-clasen-984089198/",
  },
  {
    key: "jane",
    name: "Jan B. Elsner",
    title: "Geschäftsführer / CEO",
    img: "/images/about_us/team/JanE.png",
    linkedin: "https://www.linkedin.com/in/jelsner/",
  },
  {
    key: "jens",
    name: "Jens Pelzetter",
    title: "Technischer Leiter / CTO",
    img: "/images/about_us/team/Jens.png",
    linkedin: "https://www.linkedin.com/in/jens-pelzetter-8ba407163/",
  },
  {
    key: "maria",
    name: "Maria Araujo",
    title: "UX- / Produkt-designerin",
    img: "/images/about_us/team/Maria.png",
    linkedin: "https://www.linkedin.com/in/eugeniaaraujo/",
  },
  {
    key: "bojana",
    name: "Bojana Petković",
    title: "UI- / Grafik-designerin",
    img: "/images/about_us/team/Bojana.png",
    linkedin: "http://linkedin.com/in/bojana-petkovi%C4%87/",
  },
  {
    key: "jans",
    name: "Jan Schwichtenberg",
    title: "Medizinstudent",
    img: "/images/about_us/team/JanS.png",
    linkedin: "https://www.linkedin.com/in/schwichtenberg/",
  },
  {
    key: "lynn",
    name: "Lynn Grünhagen",
    title: "Medienwiss-enschaftlerin",
    img: "/images/about_us/team/Lynn.png",
    linkedin: "",
  },
  {
    key: "lenny",
    name: "Leander Reimold",
    title: "Business Developer",
    img: "/images/about_us/team/Lenny.png",
    linkedin: "https://www.linkedin.com/in/leander-reimold-a0644b244/",
  },
  {
    key: "lauritz",
    name: "Lauritz Zaeschmar",
    title: "Business Developer",
    img: "/images/about_us/team/Lauritz.png",
    linkedin: "https://www.linkedin.com/in/lauritz-zaeschmar-60a372244/",
  },
  // {
  //   key: "Riddhi",
  //   name: "Riddhi Odedara",
  //   title: "Frontend Developer & Tester",
  //   img: "/images/about_us/team/Riddhi.png",
  //   linkedin: "https://www.linkedin.com/in/riddhi-odedara-ba39901b5/",
  // },
  {
    key: "Anna",
    name: "Anna Ray",
    title: "Executive assistant & Head of HR",
    img: "/images/about_us/team/Anna.png",
    linkedin: "https://www.linkedin.com/in/anna-ray-2ab35924b/",
  },
  {
    key: "Erik",
    name: "Erik Helms",
    title: "Warehouse Staff",
    img: "/images/about_us/team/Erik.png",
  },
  {
    key: "Matthias",
    name: "Matthias Zündel",
    title: "Wissenschaftliche Leitung / CSO (freiberuflich)",
    img: "/images/about_us/team/Matthias.png",
    linkedin: "https://www.linkedin.com/in/prof-dr-matthias-z%C3%BCndel-08900573/",
  },
  {
    key: "Nils",
    name: "Nils Jagels",
    title: "Sales Mitarbeiter",
    img: "/images/about_us/team/nils_jagels.webp",
    linkedin: "https://www.linkedin.com/in/nils-jagels-742312282/",
  },
]

/* ---------------- Beirat data ---------------- */
const BOARD: Person[] = [
  {
    key: "kai",
    name: "Kai Schuirmann",
    img: "/images/about_us/beirat/Andreas.png",
    bullets: ["Gründer von GCP-Service", "Experte für klinische Studien"],
  },
  {
    key: "andreas",
    name: "Dr. Andreas Grund",
    img: "/images/about_us/beirat/Andreas1.png",
    bullets: ["Gründer von GCP-Service", "Experte für klinische Studien"],
  },
  {
    key: "uwe",
    name: "Dr. Uwe Schwichtenberg",
    img: "/images/about_us/beirat/Uwe.png",
    bullets: ["Dermatologe und Fachreferent", "Medizinischer Expertenrat"],
  },
  {
    key: "tim",
    name: "Tim Jürgens",
    img: "/images/about_us/beirat/Tim.png",
    bullets: ["ex. VP Roche Diabetes Care", "Experte für Geschäftsentwicklung"],
  },
  {
    key: "stefan",
    name: "Stefan Bellinger",
    img: "/images/about_us/beirat/Stefan.png",
    bullets: ["Familienunternehmer", "Mentor für Unternehmensführung"],
  },
  {
    key: "tim2",
    name: "Tim Rödiger",
    img: "/images/about_us/beirat/TimRödiger.png",
    bullets: [`ex. AOK Unternehmensentwicklung`, "Berater für Kassen-Partnerschaften"],
  },
]

export default function UberUns() {
  const t = useTranslations("index.aboutUs")
  return (
    <div className={styles.page}>
      <SkinuvitaSeoHead
        title={`${t("title")} | Skinuvita`}
        description={
          "Das Team, die Gründer und der medizinische Beirat hinter Skinuvita – dem Anbieter " +
          "der ärztlich begleiteten UVB-Lichttherapie für zuhause."
        }
        canonicalPath={Routes.aboutUs}
      />
      <NavBarPatients />
      {/* Banner */}
      <section className={styles.banner}>
        <Image
          src="/images/about_us/about-us-banner.png"
          alt="Über uns Banner"
          fill
          priority
          className={styles.bannerImg}
        />
        <div className={styles.bannerOverlay} />
        <StyledText variant="h1" className={styles.bannerTitle}>
          {t("title")}
        </StyledText>
      </section>
      <section className={styles.team}>
        <StyledText variant="h2" className={styles.sectionTitle} color={skColors.turquoise[600]}>
          {t("teamTitle")}
        </StyledText>
        <InlineExpandStrip people={TEAM} shuffle variant="team" />
      </section>
      {/* Timeline */}
      <section className={styles.timeline}>
        <StyledText variant="h2" className={styles.sectionTitle} color={skColors.turquoise[600]}>
          {t("timeline")}
        </StyledText>
        <div className={styles.timelineScroller}>
          <Image
            src="/images/about_us/timeline1.svg"
            alt="Timeline track"
            width={945}
            height={278}
            className={styles.timelineLine}
            sizes="(min-width: 1920px) 1800px, (min-width: 1440px) 1600px, (min-width: 1200px) 1200px, 100vw"
          />
        </div>
      </section>
      {/* Beirat */}
      <section className={styles.board}>
        <StyledText variant="h2" className={styles.sectionTitle} color={skColors.turquoise[600]}>
          {t("board")}
        </StyledText>
        <InlineExpandStrip people={BOARD} variant="board" />
      </section>
      {/* Netzwerk */}
      <section className={styles.networkSection}>
        <Network setIsModalOpen={() => {}} style={{ marginTop: 0 }} />
      </section>
      <Footer />
    </div>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  // Next sets context.locale when i18n is enabled
  const locale = (context.locale as string) || "de"

  let messages
  try {
    messages = (await import(`../src/intl/${locale}.json`)).default
  } catch (err) {
    // fallback to default
    messages = (await import(`../src/intl/de.json`)).default
  }

  return {
    props: {
      messages,
      locale,
    },
  }
}
